import { message } from "antd";
import { atom } from "jotai";
import { nanoid } from "nanoid";

// state
const _payments = atom([]);
const _charges = atom([]);
const _redeemedBenefits = atom([]);

export const getTotalBillPaymentsAtom = atom((get) => {
  let total = 0;
  get(_payments).map((c) => {
    total += parseFloat(c.amount || 0);
  });
  return total;
});

export const getTotalBillChargesAtom = atom((get) => {
  let total = 0;
  get(_charges).map((c) => {
    total += parseFloat(c.value || 0);
  });
  return total;
});

// atoms
export const billPaymentsAtom = atom(
  (get) => get(_payments),
  (get, set, payment) => {
    set(_payments, [
      ...get(_payments),
      { recordId: nanoid(), paymentMethod: "", amount: 0 },
    ]);
  }
);

export const billChargesAtom = atom(
  (get) => get(_charges),
  (get, set, charge) => {
    set(_charges, [
      ...get(_charges),
      { id: nanoid(), chargeId: null, value: 0 },
    ]);
  }
);

export const billRedeemedBenefitsAtom = atom(
  (get) => get(_redeemedBenefits),
  (get, set, redeemedBenefits) => {
    set(_redeemedBenefits, redeemedBenefits);
  }
);

// payments handler
export const deleteBillPaymentAtom = atom(null, (get, set, recordId) => {
  set(
    _payments,
    get(_payments).filter((pay) => pay.recordId !== recordId)
  );
});

export const updateBillPaymentAtom = atom(null, (get, set, params) => {
  const { recordId, field, value } = params;

  // prevent duplicate methods
  if (
    field === "paymentMethod" &&
    get(_payments).find((pay) => pay.paymentMethod === value)
  ) {
    message.error("method already selected!");
    return;
  }

  let updatedPayment = get(_payments).find((pay) => pay.recordId === recordId);
  updatedPayment[field] = value;

  // update payments
  set(
    _payments,
    get(_payments).map((pay) => {
      if (pay.recordId === recordId) return updatedPayment;
      return pay;
    })
  );
});

export const setBillPayments = atom(null, (get, set, payments) => {
  set(_payments, payments);
});

// charges handler
export const deleteBillChargeAtom = atom(null, (get, set, id) => {
  set(
    _charges,
    get(_charges).filter((charge) => charge.id !== id)
  );
});

export const updateBillChargeAtom = atom(null, (get, set, params) => {
  const { id, field, value } = params;

  let updatedCharge = get(_charges).find((charge) => charge.id === id);
  updatedCharge[field] = value;

  // update charges
  set(
    _charges,
    get(_charges).map((charge) => {
      if (charge.id === id) return updatedCharge;
      return charge;
    })
  );
});

export const setBillCharges = atom(null, (get, set, charges) => {
  set(_charges, charges);
});
